(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/media-card/assets/javascripts/components/media-card.js') >= 0) return;  svs.modules.push('/components/tur/media-card/assets/javascripts/components/media-card.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  Image
} = svs.content.image_v2;
const {
  ReactIcon: Icon
} = svs.ui;
const {
  Card,
  CardBody
} = svs.ui.ReactCard;
const {
  useHistory
} = ReactRouterDOM;
setGlobal('svs.tur.MediaCard', _ref => {
  let {
    title,
    preamble,
    image,
    link,
    onClick,
    className = ''
  } = _ref;
  const history = useHistory();
  if (!title || !preamble || !image || !link === undefined) {
    return null;
  }

  const handleClick = e => {
    e.preventDefault();
    if (onClick) {
      onClick(e);
    } else {
      const finalLink = "".concat(history.location.pathname, "/").concat(link);
      history.push(finalLink);
    }
  };
  return React.createElement("a", {
    href: "".concat(history.location.pathname, "/").concat(link),
    onClick: handleClick
  }, React.createElement(Card, {
    className: "".concat(className, " media-card-grid")
  }, React.createElement(CardBody, {
    className: "media-card-body-grid"
  }, React.createElement("div", null, React.createElement("h2", {
    className: "h2 f-content margin-0"
  }, title), React.createElement("p", {
    className: "p f-content"
  }, preamble)), React.createElement("div", null, image && React.createElement(Image, {
    image: _objectSpread({}, image)
  }))), React.createElement("div", {
    className: "media-card-arrow"
  }, React.createElement(Icon, {
    icon: "arrow-right"
  }))));
});

 })(window);